import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const LumbiniPackage = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO BANNER */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage:
            "url('/Images/tour/lumbini-banner.webp')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Lumbini Buddhist Pilgrimage Tour</h1>

            <p className="hero-subtitle">
              3 Nights / 4 Days • Birthplace of Lord Buddha
            </p>

            <div className="hero-price">
              Starting From <span>₹17,999</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + FORM */}
        <Row className="mb-4">

          {/* LEFT SLIDER */}
          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/lumbini-banner.webp" alt="" />
                <img src="/Images/tour/lumbini.jpg" alt="" />
                <img src="/Images/tour/lumbini1.jpg" alt="" />
              </Slider>
            </div>
          </Col>

          {/* RIGHT FORM */}
          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹17,999</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>

        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Lumbini Buddhist Pilgrimage Tour</h1>
              <p>3 Nights / 4 Days • Spiritual & Heritage Experience</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Maya Devi Temple Visit</Col>
                <Col md={6}>✔ Sacred Lumbini Garden</Col>
                <Col md={6}>✔ World Peace Pagoda</Col>
                <Col md={6}>✔ International Monasteries Tour</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Explore Lumbini, the birthplace of Lord Buddha and one of
                the world's most important spiritual destinations.
                Experience peaceful monasteries, sacred gardens and
                Buddhist heritage sites.
              </p>
            </div>

            {/* Itinerary */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>Day 1 – Arrival Lumbini</Accordion.Header>
                  <Accordion.Body>
                    Arrival and hotel check-in followed by evening visit
                    to Lumbini Garden.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Day 2 – Lumbini Sightseeing
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Maya Devi Temple, Ashoka Pillar,
                    monasteries built by different countries and
                    World Peace Pagoda.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Day 3 – Spiritual Exploration
                  </Accordion.Header>
                  <Accordion.Body>
                    Meditation session and exploration of Buddhist
                    cultural heritage sites.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>Day 4 – Departure</Accordion.Header>
                  <Accordion.Body>
                    Breakfast and departure with peaceful memories.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* Inclusion Exclusion */}
            <div className="content-box">
              <Row>

                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul className="inclusion-list">
                    <li>Hotel Accommodation</li>
                    <li>Daily Breakfast</li>
                    <li>Local Sightseeing</li>
                    <li>Airport Transfers</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul className="exclusion-list">
                    <li>Personal Expenses</li>
                    <li>Travel Insurance</li>
                    <li>Lunch & Dinner</li>
                    <li>Entry Fees Not Mentioned</li>
                  </ul>
                </Col>

              </Row>
            </div>

            {/* Gallery */}
            <div className="content-box">
              <h3>Gallery</h3>

              <Row className="gallery">
                <Col md={4}>
                  <img src="/Images/tour/lumbini-banner.webp" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/lumbini1.jpg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/lumbini.jpg" alt="" />
                </Col>
              </Row>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default LumbiniPackage;